export default "__VITE_ASSET__aOXnHlzw__"